class PressModule extends HTMLElement {
  constructor() {
    super();
    const pressSlides = this.querySelectorAll(".press-module__list li");
    let lastSlide = pressSlides[pressSlides.length - 1];
    this.splideOptions = {
      destroy: true,
      arrows: false,
      perMove: 1,

      breakpoints: {
        769: {
          perMove: 4,
          perPage: 4,
          rewind: true,
          destroy: false,
        },
        500: {
          drag: false,
          perMove: lastSlide.classList.contains("is-visible") ? 1 : 3,
          perPage: 3,
        },
      },
    };
    this.pressModule = new Splide(this, this.splideOptions);
    this.pressModule.mount();

    this.touchstartX = 0;
    this.touchendX = 0;

    this.addEventListener("touchstart", (e) => {
      this.touchstartX = e.changedTouches[0].screenX;
    });

    this.addEventListener("touchend", (e) => {
      this.touchendX = e.changedTouches[0].screenX;
      this.checkDirection();
    });
  }

  checkDirection() {
    /* custom logic for a smoother scroll experience with logo groupings.
               - disabled splide's native drag functionality 
               - detects swipes, either left or right
               - jumps the slide index depending on the currently active slides
               */
    if (this.touchendX < this.touchstartX) {
      //swiped left
      let nextPage = this.pressModule.Components.Controller.getNext();
      if (nextPage == 3) {
        this.pressModule.Components.Controller.go(3);
      } else if (nextPage == 4 || nextPage == 0) {
        this.pressModule.Components.Controller.go(5);
      }
    }
    if (this.touchendX > this.touchstartX) {
      //swiped right
      let prevPage = this.pressModule.Components.Controller.getPrev();
      if (prevPage == 1) {
        this.pressModule.Components.Controller.go(3);
      } else if (prevPage == 4 || prevPage == 0) {
        this.pressModule.Components.Controller.go(0);
      }
    }
  }
}

customElements.define("press-module", PressModule);
